import React from 'react';
import { SemanticUiColorPicker } from 'Components/SemanticUiColorPicker';
import { Form } from 'semantic-ui-react';

export const SemanticUiColorPickerWrapper = ({
  input,
  label,
  required,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <Form.Field error={touched && error ? true : false} required={required}>
      {label && <label>{label}</label>}
      <SemanticUiColorPicker
        color={input.value}
        onChange={color => {
          input.onChange(color);
        }}
        {...custom}
      />
      {touched && error ? (
        <span className={'input--message-error'}>{error}</span>
      ) : null}
    </Form.Field>
  );
};



// WEBPACK FOOTER //
// ./src/common/ReduxFormFields/SemanticUiColorPickerWrapper.js